export default __webpack_public_path__ + "static/media/certificate-close.7eff7f99.svg";